export const PHRASES_DICTIONARY = {
  COPY: {
    text_copy: "You can copy it by double clicking",
    text_success_copy: "Successfully coped!",
    text_error_copy: "Error during copying!",
  },
  PROMPTS_FOR_RULES: {
    target_characteristics: `The characteristics available for selection in the "Target Characteristics" are the intersection of the characteristics of
            the selected classes in the "Classification" field.
            If no classification is selected, the intersection characteristics for all
            classifications will be available for selection.`,
    rule_text_description: `The "Rule text" field should contain a mention of each selected characteristic (the register is important).`,
    rule_text_prompt: "* First, select at least one characteristic",
    rule_text_prompt_error:
      "* The text must contain all selected Target Characteristics",
    required_filds: `fields required to be filled.`,
  },
  PROMPTS_FOR_SETTINGS: {
    choice_calendar_day_prompt: "Logs for the day of the selected date",
  },
  CLEAN_CACHE_BTN_TEXT: {
    with_necessary_roles:
      "Clears the entire Redis cache. This is useful after changing logic or fixing bugs to remove old, invalid data (e.g., values).",
    without_necessary_roles:
      "The current user doesn't have sufficient privileges to perform the operation.",
  },
  WARNINGS: {
    warning_clear_validation: "Are you sure you want to clear validation?",
    warning_clear_final_value:
      "Are you sure you want to clear the final value?\nThis will clear the validation.",
    warning_agent_validation: (count) =>
      `Are you sure you want to validate ${count} tags?`,
    warning_agent_clear_validation: (count) =>
      `Are you sure you want to clear validation for ${count} tags?`,
  },
  SUCCESS: {
    copy_link: "Link was copied!",
    report_upload: "Report uploaded successfully",
    tags_validated: (count) => `Successfully validated ${count} tags!`,
    tags_cleared: (count) => `Validation cleared for ${count} tags!`,
  },
  characteristic_required_field: "* The choice of characteristic is required",
  statistics_prompt: "From 1 to 10 classes must be selected *",
};
